import type {
  OnChangeSetting,
  OnChangeSettingsArgs,
} from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { ButtonItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';

import { includesSetting } from './includeSettings';
import {
  commonSettingsButtonLevel,
  simpleChangeAttributes,
} from '../constants';

interface OnChangeInterceptorProps extends OnChangeSettingsArgs {
  item: DocumentItem<ButtonItemAttributes>;
  onChange: OnChangeSetting;
  forceUpdateAllChildren?: boolean;
}

export const onChangeInterceptor = ({
  id,
  item,
  onChange,
  settingKey: initialSettingKey,
  value,
  values,
  forceUpdateAllChildren,
}: OnChangeInterceptorProps) => {
  const settingKey = initialSettingKey || values?.[0]?.settingKey;

  // We need this exception for the paddings because the top and bottom settings can be set at the button level in some cases
  // and in other cases they should be set to both buttons at the same time
  // The left and right paddings are always at the single button level
  if (forceUpdateAllChildren && item.children) {
    const ids = item.children.map((button) => button.id);

    onChange({ ids, settingKey, value, values });

    return;
  }

  if (item.children && includesSetting(commonSettingsButtonLevel, settingKey)) {
    const ids = item.children.map((button) => button.id);

    onChange({ ids, settingKey, value, values });

    return;
  }

  if (includesSetting(simpleChangeAttributes, settingKey) || !item.children) {
    onChange({ id, settingKey, value, values });
  }
};
